import { render } from "./SellSkin.vue?vue&type=template&id=4c89b2be&scoped=true"
import script from "./SellSkin.vue?vue&type=script&lang=js"
export * from "./SellSkin.vue?vue&type=script&lang=js"

import "./SellSkin.vue?vue&type=style&index=0&id=4c89b2be&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c89b2be"]])

export default __exports__